import React from 'react';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import '../styles/sections/IntroSection.css';
import resume from '../content/Oleg_Glotov_resume.pdf';
import Spline from '@splinetool/react-spline';
import { Fade } from 'react-awesome-reveal';

const isMobile = window.innerWidth < 600;

export const IntroSection: React.FC = () => {
  return (
    <section className="introBackground">
      <div className="introContentSection">
        <div className="sectionNumber fontSpaceMono" id="myName">
          Hi, my name is
        </div>
        <h1 className="introName fontHelveticaNeue">Oleg Glotov</h1>
        <h2 className="introQuote fontHelveticaNeue">Welcome to my portfolio</h2>
        <p className="introWriteup">
          Currently a masters student in{' '}
          <span className="introHighlight">financial mathematics</span> with a
          concentration in <span className="introHighlight">machine learning</span>{' '}
          at the University of Chicago.
        </p>
        <Fade delay={isMobile ? 400 : 400} triggerOnce>
          <Button
            href={resume}
            variant="contained"
            endIcon={<DownloadIcon />}
            sx={{
              color: 'black',
              backgroundColor: 'yellowgreen',
              height: '70px',
              width: '200px',
              borderRadius: '35px',
              fontSize: '16px',
              letterSpacing: '3px',
              '&:hover': { backgroundColor: 'white' },
            }}
          >
            Resume
          </Button>
        </Fade>
      </div>
      <div className="introSplineSection">
        <Spline scene="https://prod.spline.design/kaqR3bd5tHhm-nNc/scene.splinecode" />
      </div>
    </section>
  );
};
